/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HolidayResponse } from '../models/HolidayResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HolidaysService {
    /**
     * list holidays
     * @param tenantId tenant_id
     * @returns HolidayResponse successful
     * @throws ApiError
     */
    public static getHolidays(
        tenantId: string,
    ): CancelablePromise<HolidayResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/holidays',
            path: {
                'tenant_id': tenantId,
            },
        });
    }
}
